import React, { useState } from 'react'
import Part1CertIn from '../Reports/Web/CertInSupport-Page/Part1CertIn/Part1CertIn';
import Part2CertIn from '../Reports/Web/CertInSupport-Page/Part2CertIn/Part2CertIn';
import Part3CertIn from '../Reports/Web/CertInSupport-Page/Part3CertIn/Part3CertIn';
import { faExclamationCircle, faGlobe } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CertInHTMLReport(props) {

    const {
        handleCertInDownload,
        certInReportName, setCertInReportName, imageUrl, setImageUrl,
        certInDate, setCertInDate,
        certInCustomerName, setCertInCustomerName,
        certInLogo, setCertInLogo,
        certInApplicationName, setCertInApplicationName,
        certInApplicationUrl, setCertInApplicationUrl,
        certInStartDate, setCertInStartDate,
        certInEndDate, setCertInEndDate,
        certInTestingype, setCertInTestingType,
        certInAppDescription, setCertInAppDescription,
        certInAppEnvironment, setCertInAppEnvironment,
        certInRoles, setCertInRoles, criticality, setCriticality,
        certInReportNameError, setCertInReportNameError,
        certInDateError, setCertInDateError,
        certInCustomerNameError, setCertInCustomerNameError,
        certInLogoError, setCertInLogoError,
        certInApplicationNameError, setCertInApplicationNameError,
        certInApplicationUrlError, setCertInApplicationUrlError,
        certInStartDateError, setCertInStartDateError,
        certInEndDateError, setCertInEndDateError,
        certInTestingypeError, setCertInTestingTypeError,
        certInAppDescriptionError, setCertInAppDescriptionError,
        certInAppEnvironmentError, setCertInAppEnvironmentError,
        certInRolesError, setCertInRolesError,
        certInVulCount, setCertInVulCount, inchargeName, setInchargeName, inchargeEmail, setInchargeEmail, inchargeDesignation, setInchargeDesignation,
        certInCritical, setCertInCritical,
        certInHigh, setCertInHigh,
        certInMedium, setCertInMedium,
        certInLow, setCertInLow,
        certInInfo, setCertInInfo,
        certInA1, setCertInA1, certInA2, setCertInA2, certInA3, setCertInA3, certInA4, setCertInA4, certInA5, setCertInA5,
        certInA6, setCertInA6, certInA7, setCertInA7, certInA8, setCertInA8, certInA9, setCertInA9, certInA10, setCertInA10,
        certInVulnerabilities, setCertInVulnerabilities, certInDownloading, setCertInDownloading
    } = props

    const [openCertInInputs, setCertInOpenInputs] = useState(false)
    const [certInCurrentPage, setCertInCurrentPage] = useState(1);

    const [openCertinCancel, setOpenCertinCancel] = useState(false)

    const [clientLogoSelected, setClientLogoSelected] = useState(false)
    const [clientLogoFetched, setClientLogoFetched] = useState(false)

    function capitalizeFirstLetter(string) {
        if (typeof string !== 'string') {
            return string;
        }
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    const handleNextPage = () => {
        setCertInCurrentPage(certInCurrentPage + 1);
    }

    const handlePrevPage = () => {
        if (certInCurrentPage > 1) {
            setCertInCurrentPage(certInCurrentPage - 1);
        }
    };

    const handleCertInCancel = () => {
        setOpenCertinCancel(true)
    }

    const handleCertInDataCancel = () => {
        setOpenCertinCancel(false)
        setCertInOpenInputs(false)
        setCertInReportName('')
        setCertInDate('')
        setCertInCustomerName('')
        setCertInLogo('')
        setCertInApplicationName('')
        setCertInApplicationUrl('')
        setCertInStartDate('')
        setCertInEndDate('')
        setCertInTestingType('')
        setCertInAppDescription('')
        setCertInAppEnvironment('')
        setCertInRoles('')
        setCriticality('')
        setImageUrl('')
        setInchargeName('')
        setInchargeEmail('')
        setInchargeDesignation('')
        setCertInVulCount('')
        setCertInCritical('')
        setCertInHigh('')
        setCertInMedium('')
        setCertInLow('')
        setCertInInfo('')
        setCertInA1('')
        setCertInA2('')
        setCertInA3('')
        setCertInA4('')
        setCertInA5('')
        setCertInA6('')
        setCertInA7('')
        setCertInA8('')
        setCertInA9('')
        setCertInA10('')
        setCertInVulnerabilities([])
    }

    const handleOpenInputs = () => {
        setCertInOpenInputs(true)
        setCertInCurrentPage(1)
    }

    return (
        <div className='wrap_report_data'>

            <div className='wrap_report_certinpart'>
                <div className='certinpart' onClick={handleOpenInputs}>
                    <h1> Web CERT-In Report</h1>
                    <h2>Includes:</h2>
                    <p>Web CERT-In Report</p>
                    <p>Web CERT-In Audit Report</p>
                </div>
                <div className='wrap_globe_certin'>
                    <div>
                        <i><FontAwesomeIcon icon={faGlobe} /></i>
                    </div>
                </div>
            </div>


            {openCertInInputs && (
                <div>
                    {certInCurrentPage === 1 && <Part1CertIn
                        setCertInOpenInputs={setCertInOpenInputs}
                        handleCertInDownload={handleCertInDownload}
                        capitalizeFirstLetter={capitalizeFirstLetter}
                        handleNextPage={handleNextPage}
                        certInCurrentPage={certInCurrentPage}
                        handleCertInCancel={handleCertInCancel}

                        certInReportName={certInReportName}
                        setCertInReportName={setCertInReportName}
                        certInDate={certInDate}
                        setCertInDate={setCertInDate}
                        certInCustomerName={certInCustomerName}
                        setCertInCustomerName={setCertInCustomerName}
                        certInLogo={certInLogo}
                        setCertInLogo={setCertInLogo}
                        certInApplicationName={certInApplicationName}
                        setCertInApplicationName={setCertInApplicationName}
                        certInApplicationUrl={certInApplicationUrl}
                        setCertInApplicationUrl={setCertInApplicationUrl}
                        certInStartDate={certInStartDate}
                        setCertInStartDate={setCertInStartDate}
                        certInEndDate={certInEndDate}
                        setCertInEndDate={setCertInEndDate}
                        certInTestingype={certInTestingype}
                        setCertInTestingType={setCertInTestingType}
                        certInAppDescription={certInAppDescription}
                        setCertInAppDescription={setCertInAppDescription}
                        certInAppEnvironment={certInAppEnvironment}
                        setCertInAppEnvironment={setCertInAppEnvironment}
                        certInRoles={certInRoles}
                        setCertInRoles={setCertInRoles}

                        certInDateError={certInDateError}
                        setCertInDateError={setCertInDateError}
                        certInCustomerNameError={certInCustomerNameError}
                        setCertInCustomerNameError={setCertInCustomerNameError}
                        certInLogoError={certInLogoError}
                        setCertInLogoError={setCertInLogoError}
                        certInApplicationNameError={certInApplicationNameError}
                        setCertInApplicationNameError={setCertInApplicationNameError}
                        certInApplicationUrlError={certInApplicationUrlError}
                        setCertInApplicationUrlError={setCertInApplicationUrlError}
                        certInStartDateError={certInStartDateError}
                        setCertInStartDateError={setCertInStartDateError}
                        certInEndDateError={certInEndDateError}
                        setCertInEndDateError={setCertInEndDateError}
                        certInTestingypeError={certInTestingypeError}
                        setCertInTestingTypeError={setCertInTestingTypeError}
                        certInAppDescriptionError={certInAppDescriptionError}
                        setCertInAppDescriptionError={setCertInAppDescriptionError}
                        certInAppEnvironmentError={certInAppEnvironmentError}
                        setCertInAppEnvironmentError={setCertInAppEnvironmentError}
                        certInRolesError={certInRolesError}
                        setCertInRolesError={setCertInRolesError}
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                        criticality={criticality}
                        setCriticality={setCriticality}
                        setClientLogoSelected={setClientLogoSelected}
                        setClientLogoFetched={setClientLogoFetched}
                    />}

                    {certInCurrentPage === 2 && (
                        <Part2CertIn
                            certInCurrentPage={certInCurrentPage}
                            handlePrevPage={handlePrevPage}
                            handleNextPage={handleNextPage}
                            handleCertInCancel={handleCertInCancel}
                            handleCertInDownload={handleCertInDownload}
                            inchargeDesignation={inchargeDesignation}
                            inchargeEmail={inchargeEmail}
                            inchargeName={inchargeName}
                            setInchargeDesignation={setInchargeDesignation}
                            setInchargeEmail={setInchargeEmail}
                            setInchargeName={setInchargeName}
                            certInVulCount={certInVulCount}
                            setCertInVulCount={setCertInVulCount}
                            certInCritical={certInCritical}
                            setCertInCritical={setCertInCritical}
                            certInHigh={certInHigh}
                            setCertInHigh={setCertInHigh}
                            certInMedium={certInMedium}
                            setCertInMedium={setCertInMedium}
                            certInLow={certInLow}
                            setCertInLow={setCertInLow}
                            certInInfo={certInInfo}
                            setCertInInfo={setCertInInfo}
                            certInA1={certInA1}
                            setCertInA1={setCertInA1}
                            certInA2={certInA2}
                            setCertInA2={setCertInA2}
                            certInA3={certInA3}
                            setCertInA3={setCertInA3}
                            certInA4={certInA4}
                            setCertInA4={setCertInA4}
                            certInA5={certInA5}
                            setCertInA5={setCertInA5}
                            certInA6={certInA6}
                            setCertInA6={setCertInA6}
                            certInA7={certInA7}
                            setCertInA7={setCertInA7}
                            certInA8={certInA8}
                            setCertInA8={setCertInA8}
                            certInA9={certInA9}
                            setCertInA9={setCertInA9}
                            certInA10={certInA10}
                            setCertInA10={setCertInA10}
                        />
                    )}

                    {certInCurrentPage === 3 && (
                        <Part3CertIn
                            certInVulnerabilities={certInVulnerabilities}
                            setCertInVulnerabilities={setCertInVulnerabilities}
                            certInCurrentPage={certInCurrentPage}
                            handlePrevPage={handlePrevPage}
                            handleNextPage={handleNextPage}
                            handleCertInCancel={handleCertInCancel}
                            handleCertInDownload={handleCertInDownload}
                        />
                    )}
                </div>

            )}

            {certInDownloading &&
                <div className='downloading_page'>
                    <div className='wrap_downloading' style={{ width: "130px", height: "110px" }}>
                        <p style={{ fontSize: "14px" }}>Downloading...</p>
                        <div ><span className="loader_download" style={{ marginTop: "30px" }}></span></div>
                    </div>
                </div>
            }

            {openCertinCancel && (
                <div className='waiting_page'>
                    <div className='wrap_Waiting'>
                        <div className='wrap_waitingpage_icon'><i><FontAwesomeIcon icon={faExclamationCircle} /></i></div>
                        <h2>Canceling this action will result in the permanent loss of data, which cannot be recovered.</h2>
                        <div >
                            <button className='wrap_waiting_cancelbutton' onClick={() => setOpenCertinCancel(false)}>Cancel</button>
                            <button className='wrap_waiting_confirmbutton' onClick={handleCertInDataCancel}>Confirm</button>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default CertInHTMLReport
